export const linearGradient = (direction: string, stops: string[]): string => {
  return `linear-gradient(${direction},${stops.join(",")})`;
};
